import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams } from 'react-router-dom'

const QUESTION_KEY = 'sitting_time'

const answers: AnswerType[] = [
  {
    emoji: '🛋️',
    title: 'pages.onboarding.sittingTime.options.moreThan8',
    value: 'more_than_8',
  },
  {
    emoji: '💺',
    title: 'pages.onboarding.sittingTime.options.fourToEight',
    value: '4-8',
  },
  {
    emoji: '🪑',
    title: 'pages.onboarding.sittingTime.options.twoToFour',
    value: '2-4',
  },
  {
    emoji: '🚶',
    title: 'pages.onboarding.sittingTime.options.lessThan2',
    value: 'less_than_2',
  },
]

export default function SittingTimePage() {
  const [searchParams] = useSearchParams()
  const urlValue = searchParams.get('value')
  const preselectedValue =
    urlValue && answers.some((a) => a.value === urlValue) ? urlValue : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const input = event.target as HTMLInputElement
    const answerValue = input.value

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How many hours do you sit per day?',
      answer_key: answerValue,
      answer: answerValue,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.sittingTime.heading"
      preselectedValue={preselectedValue}
      onSubmit={onSubmit}
    />
  )
}
